import {Component, OnInit} from '@angular/core';
import { UpButtonService } from './_services/up-button.service';
import {AuthenticationService} from '@services/authentication.service';
import {Router, RouterEvent, Event} from '@angular/router'
import { filter } from 'rxjs/internal/operators/filter';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.pug',
  styleUrls: ['./app.component.sass'],
})
export class AppComponent implements OnInit {
  title = 'SBN-WebApp';
  isAuthenticated = false;
  isAuthPage = false;

  constructor(public upButtonService: UpButtonService,
              private authService: AuthenticationService,
              private router: Router) {

    this.router.events
      .pipe(filter((e: Event): e is RouterEvent => e instanceof RouterEvent))
      .subscribe((e: RouterEvent) => {
        this.isAuthPage = e.url.includes('/auth/')
      });
  }

  ngOnInit(): void {
    this.authService.isAuthenticated$
      .subscribe(user => this.isAuthenticated = !!user);
  }
}
